export default __webpack_public_path__ + "static/media/coin_xag.b89419c4.svg";